import { beacon } from './lib/beacon';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { FirebaseProvider } from './context/FirebaseContext';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <FirebaseProvider>
        <App />
      </FirebaseProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

window.addEventListener('error', (e) => beacon('window-error', e.error || e.message));
window.addEventListener('unhandledrejection', (e) => beacon('unhandled-rejection', e.reason));
